import { render, staticRenderFns } from "./InternationalFreight.vue?vue&type=template&id=b27e37b2&scoped=true&"
import script from "./InternationalFreight.vue?vue&type=script&lang=js&"
export * from "./InternationalFreight.vue?vue&type=script&lang=js&"
import style0 from "./InternationalFreight.vue?vue&type=style&index=0&id=b27e37b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27e37b2",
  null
  
)

export default component.exports